import { render } from "./QButton.vue?vue&type=template&id=735635ea&scoped=true"
import script from "./QButton.vue?vue&type=script&setup=true&lang=js"
export * from "./QButton.vue?vue&type=script&setup=true&lang=js"

import "./QButton.vue?vue&type=style&index=0&id=735635ea&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735635ea"],['__file',"src/components/UI/buttons/QButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "735635ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('735635ea', __exports__)) {
    api.reload('735635ea', __exports__)
  }
  
  module.hot.accept("./QButton.vue?vue&type=template&id=735635ea&scoped=true", () => {
    api.rerender('735635ea', render)
  })

}


export default __exports__